<h4 class="title">Authorizations List</h4>
<div class="row">
    <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div>
    <div class="col-md-8 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="client_form()" >Add</button>
    </div>
</div>

<div class="row" style="padding: 20px;">
  <div class="col-md-12">
    <div class="col-md-2">
     <input type="text" placeholder="Account Search"><button>S</button>
    </div>
    <div class="col-md-2">
      <input type="text" placeholder="Full Search"><button>S</button>
     </div>
    <div class="col-md-2">
      <button class="btn btn-primary mr-0">Personal Loan</button>
    </div>
    <div class="col-md-2">
      <button class="btn btn-primary mr-0">Auto Loan</button>
    </div>
    <div class="col-md-2">
      <button class="btn btn-primary mr-0">Credit Cards</button>
    </div>
    <div class="col-md-2">
      <button class="btn btn-primary mr-0">Sales Finance</button>
    </div>
  </div>
</div>
<div class="doc-table">

<div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

    <ng-template pTemplate="header">

            <tr style="text-align: center;" class="thhead">
                <th rowspan="2">S.No</th>
                <th rowspan="2">Account No</th>
                <th rowspan="2">Cycle Day</th>
                <th colspan="4">Authorizations</th>
                <th colspan="5">Delinquency</th>
                <th rowspan="2">Action</th>
            </tr>
              <tr class="thhead">
                <th>Request By</th>
                <th>Reason</th>
                <th>Level</th>
                <th>Details</th>
                <th>Pending since</th>
                <th>OS Amount</th>
                <th>OD Amount</th>
                <th>Bucket</th>
                <th>Days</th>
              </tr>

    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="tdrow">
            <td>{{i+1}}</td>
            <td>Type-1</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <td>Lorem ipsum.</td>
            <!-- <td>
                User
            </td>
            <td>
                Admin
            </td>
            <td>
                16-09-2020
            </td>
            <td>
                17-09-2020
            </td> -->
            <td class="act">
                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                <!-- <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="profile()" pTooltip="Profile"></i> -->
            </td>
        </tr>
    </ng-template>
 </p-table>  </div>

</div>
